/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_Scope_TagsInputs */

const he_account_notifications_scope_tags = /** @type {(inputs: Account_Notifications_Scope_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תגיות`)
};

const en_account_notifications_scope_tags = /** @type {(inputs: Account_Notifications_Scope_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Account_Notifications_Scope_TagsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_scope_tags = /** @type {((inputs?: Account_Notifications_Scope_TagsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Scope_TagsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_scope_tags(inputs)
	return en_account_notifications_scope_tags(inputs)
});